import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {PaginationResponse} from "../../models/paginationResponse";
import {UserBlockRuleRow} from "../../models/userBlock";

export async function userBlockRulesListApi(page: number, count: number, userId?: bigint)
    : Promise<RequestResultValue<PaginationResponse<UserBlockRuleRow>>> {
    const result = await HttpService.getInstance().adminFetch(
        `UserBlockRules/list`,
        "POST",
        {
            page: page,
            count: count,
            userId: typeof userId !== 'undefined' && userId !== BigInt(-1) ? userId : null,
        }
    );
    if (result.result) {
        return new RequestResultValue<PaginationResponse<UserBlockRuleRow>>(true, result.value as PaginationResponse<UserBlockRuleRow>);
    }
    return new RequestResultValue<PaginationResponse<UserBlockRuleRow>>(false);
}

export async function userBlockRulesSetApi(userId: bigint, rule: number, comment?: string): Promise<RequestResult> {
    const result = await HttpService.getInstance().adminFetch(
        `UserBlockRules/set`,
        "POST",
        {
            userId: userId,
            rule: rule,
            comment: comment || ''
        }
    );
    if (result.result) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function userBlockRulesGetApi(userId: bigint): Promise<RequestResultValue<UserBlockRuleRow | null>> {
    const result = await HttpService.getInstance().adminFetch(
        `UserBlockRules/${userId.toString()}/rules`,
        "GET"
    );
    if (result.result) {
        return new RequestResultValue<UserBlockRuleRow | null>(true, (result.value as UserBlockRuleRow) ?? null);
    }
    return new RequestResultValue<UserBlockRuleRow | null>(false);
}


